import React, { forwardRef, useContext, useEffect, useState } from 'react';
import { API } from 'aws-amplify';
import { t } from 'i18next';
import i18n from '../../i18n';
import Select from 'react-select';

import DataPlaceholder from './DataPlaceholder';
import { ReactComponent as enUSImage } from '../../image/en-us-icon.svg';
import { ReactComponent as esUSImage } from '../../image/es-us-icon.svg';
import { ShipyardContext, UserStateContext } from '../Context';

import './LanguageSelector.scss';
import { toast } from 'react-toastify';

const LanguageSelector = forwardRef((props, ref) => {
    const { doingAjax } = useContext(UserStateContext);
    const { userSettings, updateUserSettings } = useContext(ShipyardContext);
    const [language, setLanguage] = useState(userSettings?.LanguagePreference ? userSettings.LanguagePreference : i18n.language);
    const [internalAjax, setInternalAjax] = useState(false);

    const languageHandler = (event) => {
        setLanguage(event.value);
        if (props.changeCallback) {
            props.changeCallback(event.value);
            return;
        }

        updateUserSettings((prev) => {
            return Object.assign(prev, { LanguagePreference: event.value });
        });
        if (userSettings.Retrieved) {
            setInternalAjax(true);
            API.patch('ShipyardAPI', '/usersettings', {
                body: {
                    LanguagePreference: event.value,
                },
            })
                .then((response) => {
                    setInternalAjax(false);
                    toast.success(t('LanguageSelector.LanguageChanged'));
                })
                .catch((error) => {
                    setInternalAjax(false);
                    toast.error(t('General.AjaxError'));
                });
        }
    };

    useEffect(() => {
        if (props.changeCallback) return;
        if (language !== null) {
            i18n.changeLanguage(language);
        }
    }, [language, props.changeCallback]);

    useEffect(() => {
        if (props.value) {
            setLanguage(props.value);
        }
    }, [props.value]);

    useEffect(() => {
        if (userSettings?.LanguagePreference) setLanguage(userSettings.LanguagePreference);
    }, [userSettings.Retrieved, userSettings.LanguagePreference]);

    const languageOptions = [
        { value: 'en-US', label: 'English', image: enUSImage },
        { value: 'es-US', label: 'Español', image: esUSImage },
    ];

    return (
        <div className="language-selector-container">
            <div id="language-selector-label">{t('UserSettings.LanguagePref')}</div>
            {props.showDataPlaceholder ? (
                <DataPlaceholder />
            ) : (
                <Select
                    value={languageOptions.find((item) => item.value === language)}
                    aria-labelledby="language-selector-label"
                    ref={ref}
                    options={languageOptions}
                    onChange={languageHandler}
                    className="language-selector"
                    classNamePrefix="language-select"
                    isSearchable={false}
                    isDisabled={props.disabled | (doingAjax ? doingAjax : internalAjax ? internalAjax : false)}
                    menuPlacement={'auto'}
                    formatOptionLabel={(localization) => (
                        <div className={'option-container option-container-' + localization.value}>
                            <span className="language-selector-icon">
                                <localization.image height="2rem" />
                            </span>
                            <span>{' - '}</span>
                            <span className="language-selector-text">{localization.label}</span>
                        </div>
                    )}
                    components={{
                        IndicatorSeparator: () => null,
                    }}
                />
            )}
        </div>
    );
});

LanguageSelector.displayName = 'LanguageSelector';

export default LanguageSelector;
